import { Injectable, Renderer2, RendererFactory2, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { NgxIzitoastService } from 'ngx-izitoast';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private renderer2: Renderer2;

  constructor(
    rendererFactory: RendererFactory2,
    public iziToast: NgxIzitoastService,
    @Inject(DOCUMENT) private _document,
  ) {
    this.renderer2 = rendererFactory.createRenderer(null, null);
  }

  async showToast(message: string, type: string, confirmationAction = undefined): Promise<any> {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    if (type == 'success') {
      s.text = `successToast("${message}")`;
    } else if (type == 'error') {
      s.text = `dangerToast("${message}")`;
    } else if (type == 'warning') {
      s.text = `warningToast("${message}")`;
    } else if (type == 'warningConfirmation') {
      try {
        return await this.warningConfirmationToast(message, confirmationAction);
      } catch (error) {
        return error;
      }
    }

    this.renderer2.appendChild(this._document.body, s);
  }

  warningConfirmationToast(msg, yesAction = undefined): Promise<any> {
    return new Promise((resolve, reject) => {
      this.iziToast.question({
        close: false,
        overlay: true,
        zindex: '999',
        title: 'Warning',
        message: msg,
        position: 'bottomRight',
        backgroundColor: '#BC5459',
        messageColor: '#fff',
        titleColor: '#fff',
        icon: 'fa fa-ban',
        iconColor: '#fff',
        // theme: 'dark',
        // messageSize: '16px',
        // class: 'notificationMsg',
        buttons: [
          [
            '<button><b>Yes</b></button>',
            function (instance, toast) {
              instance.hide({ transitionOut: 'fadeOut' }, toast, 'Yes');
            },
          ],
          [
            '<button>No</button>',
            function (instance, toast) {
              instance.hide({ transitionOut: 'fadeOut' }, toast, 'No');
            },
            true,
          ],
        ],
        onClosing: function (instance, toast, closedBy) {
          if (closedBy == 'Yes') {
            if (yesAction) resolve(yesAction());
          }
          reject('user rejected confirmation');
        },
        onClosed: undefined,
      });
    });
  }
}
